'use client'

import { memo } from 'react'

import {
  DeliverySlotsByTimeOfTheDay,
  timesOfTheDaySectionTitles,
  TMSDeliverySlotsArraySlot
} from 'modules/delivery'
import LoadingIndicator from 'shared/ui/LoadingIndicator/LoadingIndicator'

import { DeliverySlotSection } from './DeliverySlotSection'

import styles from './DeliverySlotGrid.module.scss'

interface DeliverySlotGridProps {
  isFetchingSlots: boolean
  deliverySlots: DeliverySlotsByTimeOfTheDay | null
  emptyDeliverySlots: DeliverySlotsByTimeOfTheDay | null
  selectedDeliverySlots: TMSDeliverySlotsArraySlot[]
  hoverPreviewSlots: {
    slots: TMSDeliverySlotsArraySlot[]
    action: 'add' | 'remove'
  } | null
  setHoverPreviewSlots: React.Dispatch<
    React.SetStateAction<{
      slots: TMSDeliverySlotsArraySlot[]
      action: 'add' | 'remove'
    } | null>
  >
  handleChangeDeliverySlot: (
    value: boolean,
    slot?: TMSDeliverySlotsArraySlot
  ) => void
  getAffectedSlotsCallback: (
    slot: TMSDeliverySlotsArraySlot,
    action: 'add' | 'remove'
  ) => TMSDeliverySlotsArraySlot[]
}

/**
 * Component that displays the grid of delivery time slots
 * Handles loading state and renders time sections (morning, afternoon, evening)
 */
const DeliverySlotGrid: React.FC<DeliverySlotGridProps> = ({
  isFetchingSlots,
  deliverySlots,
  emptyDeliverySlots,
  selectedDeliverySlots,
  hoverPreviewSlots,
  setHoverPreviewSlots,
  handleChangeDeliverySlot,
  getAffectedSlotsCallback
}) => {
  if (isFetchingSlots) {
    return (
      <div className={styles.center}>
        <LoadingIndicator size={40} />
      </div>
    )
  }

  return (
    <div className={styles.deliverySlotsWrapper}>
      {(['morning', 'afternoon', 'evening'] as const).map(timeOfDay => (
        <DeliverySlotSection
          key={timeOfDay}
          title={timesOfTheDaySectionTitles[timeOfDay]}
          slots={deliverySlots?.[timeOfDay]}
          emptySlots={emptyDeliverySlots?.[timeOfDay]}
          deliverySlots={deliverySlots}
          selectedDeliverySlots={selectedDeliverySlots}
          hoverPreviewSlots={hoverPreviewSlots}
          setHoverPreviewSlots={setHoverPreviewSlots}
          handleChangeDeliverySlot={handleChangeDeliverySlot}
          getAffectedSlotsCallback={getAffectedSlotsCallback}
        />
      ))}
    </div>
  )
}

export default memo(DeliverySlotGrid)
